import { render } from "./BookItem.vue?vue&type=template&id=0ab98edc&scoped=true"
import script from "./BookItem.vue?vue&type=script&lang=js"
export * from "./BookItem.vue?vue&type=script&lang=js"

import "./BookItem.vue?vue&type=style&index=0&id=0ab98edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab98edc"]])

export default __exports__